// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__16-g7","consentsList":"PatientConsents_consentsList__3vuNj","consentsListEmpty":"PatientConsents_consentsListEmpty__25o6r"};